







      
import Debug from 'debug'
import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import hljs from 'highlight.js'

import UiTaskHeaderComponent from '@/app/shared/components/ui/ui-task-header-component.vue';
import HelpPopupComponent from "@/app/presenter/components/help-popup-component.vue";
import * as Api from "@/app/interaction/api";
import { CodeContent } from './code-content'

@Component({})
export default class CodeComponent extends Vue implements Api.InteractiveComponent<{}, CodeContent> {
  
  @Prop({
    required: true
  })
  public meta: Api.InteractionComponentMeta;
  
  @Prop({
    required: true
  })
  public content: CodeContent;
  
  @Prop({
    required: true
  })
  public state: {} | null;

  private get classes() {
    let classes: Record<string, boolean> = {}
    if (this.content.language) {
      classes[`language-${this.content.language}`] = true
    }

    return classes
  }
  
  private mounted() {
    const container = <HTMLElement>this.$refs['code-container'];
    hljs.highlightElement(container)
  }

  // NOTE: not used
  @Emit('interaction-result-changed')
  public emitInteractionResultChanged() {
    const result: Api.Result = {
      progress: 1,
      status: 'completed'
    }
    return result
  }
  
  // NOTE: not used
  @Emit('interaction-state-changed')
  public emitInteractionStateChanged() {
    return {}
  }
}  
